<template>
<div class="container">
    <div class="row">
        <RegisterHeader />
        <BoxRegister class="h-100">
            <div class="col-12 align-items-start" v-if="registerStatus == 0">
                <div class="row ">
                    <div class="col-6 pt-5 mb-5">
                        <h4 :class="`col-12 px-0 c-${getPrimaryColor}four bold`">
                            Vamos cadastrar sua empresa?
                        </h4>
                        <p class="col-12 px-0 c-ndarkfour regular">
                            Complete o cadastro para começar a antecipar seus recebíveis!
                        </p>
                        <h5 :class="`mt-5 mb-3 c-${getPrimaryColor}four`">
                            <SimplifiedRegistration :color="getPrimaryColorHex.four" :secundaryColor="getPrimaryColorHex.two" :circleColor="getPrimaryColorHex.one" :circleLineColor="getPrimaryColorHex.three"/> Cadastro simplificado
                        </h5>
                        <!--
                        <p class="col-12 px-0 pb-1 c-ndarkfour regular">
                            Consiga <b>rápido acesso</b> às opções de crédito de determinados financiadores da plataforma.
                        </p>
                        -->
                        <p class="col-12 px-0 my-3 c-ndarkfour medium">
                            Para essa modalidade, você vai precisar de:
                        </p>
                        <h6 v-for="(document, index) in companyDocuments" :key="index" class="col-12 px-0 mt-2 c-ndarkfour regular">
                            <CheckPayment color="#33BDA3" class="mr-2" size="18"/>{{ document.title }}
                        </h6>
                        <!--
                        <h6 class="col-12 px-0 mt-2 c-ndarkfour regular">
                            <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Contrato Social;
                        </h6>
                        <h6 class="col-12 px-0 mt-2 c-ndarkfour regular">
                            <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Última atualização contratual (se houver);
                        </h6>
                        <h6 class="col-12 px-0 mt-2 c-ndarkfour regular">
                            <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Cartão CNPJ;
                        </h6>
                        <h6 class="col-12 px-0 mt-2 c-ndarkfour regular">
                            <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Ata de assembleia (se houver);
                        </h6>
                        -->
                        <div class="mt-5">
                            <Button @click="nextStep()" class="mr-3" :color="getPrimaryColor">
                                Iniciar cadastro
                            </Button>
                        </div>
                    </div>
                    <div class="col-5 d-flex align-items-end justify-content-end flex-column pt-5">
                        <RegisterPending class="w-100 h-100 pt-5 pl-5 pr-0" :primaryColor="getIlustraPrimaryColor" :secundaryColor="getIlustraSecundaryColor"/>
                    </div>
                </div>
            </div>
            <div class="col-12 d-flex align-items-start" v-else-if="registerStatus == 2">
                <div class="col-6 pt-5">
                    <h4 :class="`col-12 px-0 c-${getPrimaryColor}four bold`">
                        Seu cadastro está em análise
                    </h4>
                    <p class="col-12 px-0 c-ndarkfour regular">
                        Faremos a análise do seu cadastro e dentro de 48h entraremos<br>
                        em contato para informar se sua ficha foi aprovada.<br>
                        <br>Caso haja divergências, é só revisar as informações indicadas<br>
                        e reenviar o cadastro.
                    </p>
                    <!-- <p class="col-12 px-0 mt-5 mb-3 c-ndarkfour bold">
                        Após nossa aprovação, estes são os próximos passos:
                    </p>
                    <h6 class="col-12 px-0 mt-2 c-ndarkfour regular">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Assinatura de contrato pelas partes envolvidas;
                    </h6>
                    <h6 class="col-12 px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                        <div>
                            Abertura de conta Cashforce por parte dos sócios,<br> 
                            administradores e procuradores da empresa (opcional);
                        </div>
                    </h6>
                    <h6 class="col-12 px-0 mt-2 c-ndarkfour regular">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Aproveite todos os benefícios da Cashforce!
                    </h6> -->
                    <div class="col-12 mt-5 mb-5 px-0">
                        <a :href="`${urlMarketplace}/home`" class="px-0">
                            <Button class="mr-3" :color="getPrimaryColor">
                                Voltar para o início
                            </Button>
                        </a>
                    </div>
                </div>
                <div class="col-6 d-flex align-items-end justify-content-end">
                    <RegisterAnalyse class="w-100 h-100 pt-5" :primaryColor="getPrimaryColorHex.five" :secundaryColor="getSecundaryColorHex.five"/>
                </div>
            </div>
            <div class="col-12 d-flex align-items-start" v-else-if="registerStatus == 3">
                <div class="col-6 pt-5">
                    <h4 :class="`col-12 px-0 c-${getPrimaryColor}four bold`">
                       Revise os dados do seu cadastro
                    </h4>
                    <p class="col-12 px-0 c-ndarkfour regular">
                        Nossa equipe identificou alguma inconsistência no cadastro da sua empresa e você precisará revisar as informações e/ou documentos que enviou.
                        <br><br>
                        Clique em "mensagem” para identificar quais informações precisam ser atualizada para finalizar o cadastro.
                    </p>
                    <div class="col-12 mt-5 mb-5 px-0">
                        <Button class="mr-4" @click="nextStep()" :color="getPrimaryColor">
                            Começar revisão
                        </Button>

                        <Button type="outline" @click="dialogVisible = true" v-if="$store.state.register.company.cnpj.review" :color="getPrimaryColor">
                            Mensagem
                        </Button>
                    </div>
                </div>
                <div class="col-6">
                    <RegisterInReview class="w-100 h-100 pt-5" :primaryColor="getIlustraPrimaryColor" :secundaryColor="getIlustraSecundaryColor"/>
                </div>
            </div>
            <div class="col-12 d-flex align-items-start" v-else-if="registerStatus == 1">
                <div class="col-7 ml-n2 px-0 py-5">
                    <h4 :class="`col-12 px-0 c-${getPrimaryColor}four bold`">
                        Parabéns! Seu cadastro está completo
                    </h4>
                    <p class="col-12 px-0 c-ndarkfour regular">
                        O cadastro da sua empresa foi aprovado com sucesso pela nossa equipe. 
                       <br><br>
                    </p>
                    <p class="mt-3">
                        Agora, você já pode aproveitar todos os benefícios da nossa plataforma, incluindo a solicitação de antecipações de forma prática e segura.
                    </p>
                    <div class="col-12 mt-5 mb-5 px-0">
                        <a :href="`${urlMarketplace}/home`" class="px-0">
                            <Button class="mr-3" :color="getPrimaryColor">
                                Voltar para o início
                            </Button>
                        </a>
                    </div>
                    <!--
                    <h5 class="mt-4">
                        <ComplementaryRegistrationStar :primaryColor="getPrimaryColorHex.three" :secundaryColor="getPrimaryColorHex.one" :starColor="getPrimaryColorHex.four" />
                        <span :class="`ml-2 c-${getPrimaryColor}four bold`">
                            Cadastro complementar
                        </span>
                    </h5>
                    <p class="mt-3">
                        Agora, você tem a opção de complementar o seu cadastro! Ao fornecer<br>
                        mais alguns dados sobre a sua empresa e seus sócios, você garante<br>
                        <strong>acesso a todos os financiadores da plataforma</strong>. Quanto mais informações<br>
                        forem preenchidas, mais propostas de financiamento podem ser recebidas!
                        <br><br>
                    </p>
                    
                    <p class="c-nmidone medium">
                        EMPRESA
                    </p>
                    <p class="c-ndarkfour medium">
                        Para complementar esta etapa do cadastro, você vai precisar adicionar:
                    </p>
                    <h6 class="px-0 mt-3 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Ficha cadastral PJ preenchida;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Declaração de instituições financeiras;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Faturamento dos últimos 24 meses;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Balanço dos últimos 24 meses;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            DRE dos últimos 24 meses;
                        </div>
                    </h6>
                    <div class="col-12 mt-4 mb-5 px-0 pt-3">
                        <Button @click="redirectToDocs" class="mr-3" :color="getPrimaryColor">
                            Iniciar cadastro complementar
                        </Button>
                        <Button @click="downloadDocumentsCompany" type="outline" :color="getPrimaryColor" v-if="getWhiteLabel === 'CASHFORCE'">
                            <Download size="12" :color="getPrimaryColorHex.four" /> Baixar fichas
                        </Button>
                        
                    </div>
                    -->
                </div>
                <div class="col-5 px-0 py-5 ml-4 d-flex align-items-end justify-content-end flex-column">
                    <!--
                    <div>
                        <HelpZipFiles color="#727D94" />
                    </div>
                    -->
                    <RegisterComplete class="w-100 h-100 pt-5" :primaryColor="getIlustraPrimaryColor" :secundaryColor="getIlustraSecundaryColor" />
                </div>
            </div>
            <div class="col-12 d-flex align-items-start" v-else-if="registerStatus == 1 && enableComplementaryRegister">
                <div class="col-7 ml-n2 px-0 py-5">
                    <h4 class="col-12 px-0 c-bluefour bold">
                        Parabéns! Seu cadastro está completo
                    </h4>
                    <p class="col-12 px-0 c-ndarkfour regular">
                        O cadastro da sua empresa foi aprovado pela nossa equipe! Você já pode solicitar financiamentos e antecipações!
                       <br><br>
                    </p>
                    <h5 class="mt-4">
                        <ComplementaryRegistrationStar /><span class="ml-2 c-bluefour bold">Cadastro complementar</span>
                    </h5>
                    <p class="mt-3">
                        Agora, você tem a opção de complementar o seu cadastro! Ao fornecer<br>
                        mais alguns dados sobre a sua empresa e seus sócios, você garante<br>
                        <strong>acesso a todos os financiadores da plataforma</strong>. Quanto mais informações<br>
                        forem preenchidas, mais propostas de financiamento podem ser recebidas!
                        <br><br>
                    </p>
                    <p class="c-nmidone medium">
                        EMPRESA
                    </p>
                    <p class="c-ndarkfour medium">
                        Para complementar esta etapa do cadastro, você vai precisar adicionar:
                    </p>
                    <h6 class="px-0 mt-3 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Ficha cadastral PJ preenchida;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Declaração de instituições financeiras;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Faturamento dos últimos 24 meses;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            Balanço dos últimos 24 meses;
                        </div>
                    </h6>
                    <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                        <CheckPayment color="#33BDA3" class="mr-2" size="18" />
                        <div>
                            DRE dos últimos 24 meses;
                        </div>
                    </h6>
                    <div class="col-12 mt-4 mb-5 px-0 pt-3">
                        <Button @click="redirectToDocs" class="mr-3">
                            Iniciar cadastro complementar
                        </Button>
                        <!--
                        <Button @click="downloadDocumentsCompany" type="outline" v-if="this.getWhiteLabel == 'CASHFORCE'">
                            <Download size="12" color="#0927BC" /> Baixar fichas
                        </Button>
                        -->
                    </div>
                </div>
                
                <div class="col-5 px-0 py-5 ml-4 d-flex align-items-end justify-content-end flex-column">
                    <!--
                    <div>
                        <HelpZipFiles color="#727D94" />
                    </div>
                    -->
                    <RegisterComplete class="w-100 h-100 pt-5" :primaryColor="getIlustraPrimaryColor" :secundaryColor="getIlustraSecundaryColor" />
                </div>
                
            </div>
            <div class="col-12 d-flex align-items-start" v-else>
                <div class="col-6 pt-5">
                    <h4 :class="`col-12 px-0 c-${getPrimaryColor}four bold`">
                        Parabéns! Seu cadastro está completo
                    </h4>
                    <p class="col-12 px-0 c-ndarkfour regular">
                       O cadastro da sua empresa foi aprovado pela nossa equipe. Agora você pode solicitar financiamentos e antecipações com as melhores taxas e os mais diversos financiadores.
                       <br><br>
Lembre-se de que daqui a um ano, você ou alguém da sua empresa precisará atualizar essas informações, para que o cadastro não fique defasado e não perca nenhuma oportunidade de financiamento.
                    </p>
                    <div class="col-12 mt-5 mb-5 px-0">
                        <a :href="`${urlMarketplace}/home`" class="px-0">
                            <Button class="mr-3" :color="getPrimaryColor">
                                Voltar para o início
                            </Button>
                        </a>
                    </div>
                </div>
                <div class="col-6">
                    <RegisterComplete class="w-100 h-100 pt-5" :primaryColor="getIlustraPrimaryColor" :secundaryColor="getIlustraSecundaryColor" />
                </div>
            </div>
            
        </BoxRegister>
    </div>
    <ReviewRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible=$event" @nextStep="nextStep" :review="$store.state.register.company.cnpj.review" />
</div>
</template>

<script>
import RegisterHeader from '@/components/register/RegisterHeader'
//import CompanyStatus from '@/components/status/CompanyStatus'
import ReviewRegister  from '@/components/modals/ReviewRegister'
import BoxRegister from '@/components/box/BoxRegister'
import RegisterPending from '@/components/ilustra/RegisterPending'
import RegisterAnalyse from '@/components/ilustra/RegisterAnalyse'
import RegisterComplete from '@/components/ilustra/RegisterComplete'
import RegisterInReview from '@/components/ilustra/RegisterInReview'
import SimplifiedRegistration from '@/components/icons/SimplifiedRegistration'
import CheckPayment from '@/components/icons/CheckPayment'
import ComplementaryRegistrationStar from '@/components/icons/ComplementaryRegistrationStar'
//import Download from '@/components/icons/Download'
//import HelpZipFiles from '@/components/register/HelpZipFiles'
import getCompany from '@/api/getCompany'
import userRules from '@/api/userRules'
import documentsList from '@/utils/documentsList'
import getWhiteLabel from '@/utils/getWhiteLabel'
export default {
    components: {
        RegisterHeader,
        ReviewRegister,
        //CompanyStatus,
        BoxRegister,
        RegisterPending,
        RegisterAnalyse,
        RegisterComplete,
        RegisterInReview,
        SimplifiedRegistration,
        CheckPayment,
        ComplementaryRegistrationStar,
        //Download,
        //HelpZipFiles,
    },
    data() {
        return {
            backToCompanyHome: false,
            dialogVisible: false,
        }
    },
    computed: {
        registerStatus() {
            return this.$store.state.user ? this.$store.state.user.registerComplete : false 
        },
        enableComplementaryRegister() {
            return !this.$store.state.user.userAdm
            && this.$store.state.user.companyType == '1'
            && !this.$store.state.register.company.cnpj.complementaryRegister
        },
        urlMarketplace() {
            return this.getServiceUrls.MARKETPLACE
        },
        companyDocuments() {
            const whitelabel = getWhiteLabel(true) 
            let key = 'company'
            if (whitelabel === 'carbon') key += 'Carbon'
            if (whitelabel === 'universo') key += 'Universo'
            return documentsList[key]
        },
    },
    methods: {
        nextStep() {
            this.$router.push(`/company/register/${this.$route.params.idCNPJ}/0`)
        },
        redirectToDocs() {
            this.$router.push(`/company/register/${this.$route.params.idCNPJ}/3`)
        },
        downloadDocumentsCompany() {
            window.open('https://files.cashforce.com.br/fichas-cadastrais-empresa.zip')
        }
    },
    async created() {
        await getCompany({ cnpjId: this.$route.params.idCNPJ, companytype: 1 })
        await userRules()
        this.$store.commit('register/setFormIsChanged', false)
        if (this.$store.state.user.registerComplete == 0) {
            if (this.$store.state.register.company.cnpj.registerStep > 0 && this.$store.state.register.company.cnpj.registerStep <= 3) {
                this.$router.push(`/company/register/${this.$route.params.idCNPJ}/${this.$store.state.register.company.cnpj.registerStep}`)
            }
            if (this.$store.state.register.company.cnpj.registerStep == 5) {
                this.$router.push(`/company/register/${this.$route.params.idCNPJ}/partner/message`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
div{
    height: 100%;
}
</style>
